import React, { useMemo } from 'react'
import OfferInclusionItem from 'components/Common/Inclusions/OfferInclusionItem'
import { buildEvergreenPackageInclusions } from 'lib/cruises/cruiseInclusionsUtils'

interface Props {
  evergreenInclusions?: Array<App.EvergreenInclusion>
  cabinType?: string
  cabinCategory?: string
}

function CruiseEvergreenInclusionList({ evergreenInclusions, cabinCategory, cabinType }: Props) {
  const inclusions = useMemo(() => {
    const filteredInclusions = (evergreenInclusions ?? [])
      .filter((inclusion) => {
        const categoryMatch = !cabinCategory || inclusion.cabinCategories.includes(cabinCategory)
        const typeMatch = !cabinType || inclusion.cabinTypes.includes(cabinType)

        return categoryMatch && typeMatch
      })

    return buildEvergreenPackageInclusions(filteredInclusions)
  }, [evergreenInclusions, cabinCategory, cabinType])

  return <>
    {!!inclusions.length && inclusions.map((inclusion) => <OfferInclusionItem
      key={inclusion.id}
      inclusion={inclusion}
      colour="highlight-secondary"
    />)}
  </>
}

export default CruiseEvergreenInclusionList
